import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "./Navbar.css";
import { api, ENDPOINTS } from "../../services/apiConfig";

const Navbar = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [userName, setUserName] = useState("User");
  const [userEmail, setUserEmail] = useState("");
  const [businessName, setBusinessName] = useState(""); // State for business name
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Fetch profile data when component mounts
    fetchProfileData();

    // Get user info from localStorage or state management
    const getUserInfo = () => {
      // This is a placeholder - replace with your actual user data retrieval
      const userInfo = localStorage.getItem('userInfo');
      if (userInfo) {
        try {
          const parsedInfo = JSON.parse(userInfo);
          setUserName(parsedInfo.name || "User");
          setUserEmail(parsedInfo.email || "");
        } catch (e) {
          console.error("Error parsing user info", e);
        }
      }
    };

    getUserInfo();

    const closeMenu = (e) => {
      if (!e.target.closest('.nav') && menuOpen) {
        setMenuOpen(false);
      }
      if (!e.target.closest('.account-dropdown') && dropdownOpen) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('click', closeMenu);
    return () => document.removeEventListener('click', closeMenu);
  }, [menuOpen, dropdownOpen]);

  // Function to fetch profile data from API
  const fetchProfileData = async () => {
    try {
      const token = localStorage.getItem('token');
      
      if (!token) {
        console.error("No token found");
        return;
      }

      const response = await fetch('http://203.161.55.192:8086/vservice/api/v1/auth/profile', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        // Set business name from API response
        setBusinessName(data.businessName || "");
        // We could also update other user info here if needed
        setUserEmail(data.email || "");
        setUserName(data.firstName ? `${data.firstName} ${data.otherName || ''}`.trim() : "User");
        
        // Save profile data to localStorage for future use
        localStorage.setItem('profileData', JSON.stringify(data));
      } else {
        console.error("Failed to fetch profile data");
      }
    } catch (error) {
      console.error("Error fetching profile data:", error);
    }
  };

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const handleLogout = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');

      // First properly clean up localStorage before making API call
      localStorage.removeItem('token');
      localStorage.removeItem('tokenExpiry');
      localStorage.removeItem('userInfo');
      localStorage.removeItem('profileData');

      // Then attempt API call - but don't block on it
      try {
        await api.vendor.post(ENDPOINTS.vendor.logout, {}, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
      } catch (apiError) {
        console.error("API logout error:", apiError);
        // Fail silently, since we already cleaned up localStorage
      }

      toast.success("Logged out successfully", {
        position: "top-center",
        autoClose: 2000,
      });

      // Use setTimeout to ensure React state updates and toast display 
      // before navigation, preventing component unmounting issues
      setTimeout(() => {
        // Navigate to login
        navigate('/login', { replace: true });
      }, 100);

    } catch (error) {
      console.error("Logout error:", error);

      // Ensure localStorage is cleared even in error case
      localStorage.removeItem('token');
      localStorage.removeItem('tokenExpiry');
      localStorage.removeItem('userInfo');
      localStorage.removeItem('profileData');

      toast.info("You have been logged out", {
        position: "top-center",
        autoClose: 2000,
      });

      // Same delayed navigation to prevent unmounting issues
      setTimeout(() => {
        navigate('/login', { replace: true });
      }, 100);
    } finally {
      setLoading(false);
    }
  };

  const profile = () => {
    navigate('/d/vendor-profile');
  }

  const dashboard = () => {
    navigate('/d/vendor-dashboard')
  }


  const Profile = () => {
    navigate('/d/vendor-profile')
  }


  // Nav links - moved outside to make them accessible in both desktop and mobile views
  const navLinks = (
    <ul className="nav-links">
      <li>
        <a onClick={dashboard}>
          <i className="fas fa-home"></i>
          <span>Dashboard</span>
        </a>
      </li>
      <li>
        <a onClick={Profile}>
          <i className="fas fa-users"></i>
          <span>Profile</span>
        </a>
      </li>
      <li>
        <a href="#about">
          <i className="fas fa-info-circle"></i>
          <span>About Us</span>
        </a>
      </li>
      <li>
        <a href="#contact">
          <i className="fas fa-envelope"></i>
          <span>Contact</span>
        </a>
      </li>
    </ul>
  );

  return (
    <nav className="nav">
      <div className="contain">
        <button className="menu-toggle" onClick={toggleMenu} aria-expanded={menuOpen}>
          <span className="menu-icon"></span>
        </button>
        
        <div className="navbar-logo">
          <img src="/assets/genie.png" alt="Logo" className="navbar-logo-image" />
        </div>

        {/* Desktop navigation links */}
        <div className="desktop-nav">
          {navLinks}
        </div>

        <div className={`mobile-overlay ${menuOpen ? "active" : ""}`}>
          <div className="mobile-nav-container">
            {/* Mobile navigation links */}
            <div className={`nav-links ${menuOpen ? "open" : ""}`}>
              {navLinks}
            </div>
          </div>
        </div>

        <div className={`account-dropdown ${dropdownOpen ? "active" : ""}`}>
          <button className="account-button" onClick={toggleDropdown}>
            <i className="fas fa-user account-icon"></i>
            <span className="account-text">Account</span>
            <i className={`fas fa-chevron-down dropdown-arrow ${dropdownOpen ? "up" : ""}`}></i>
          </button>
          
          <div className="dropdown-menu">
            <div className="dropdown-header">
              <div className="user-avatar">
                <i className="fas fa-user"></i>
              </div>
              <div className="user-info">
                {/* Display business name instead of user name */}
                <p className="user-name">{businessName || "Business"}</p>
                <p className="user-email">{userEmail}</p>
              </div>
            </div>
            
            <ul className="dropdown-links">
              <li>
                <a onClick={profile}>
                  <i className="fas fa-user-circle icon"></i>
                  <span>Profile</span>
                </a>
              </li>
              <li>
                <a href="#settings">
                  <i className="fas fa-cog icon"></i>
                  <span>Settings</span>
                </a>
              </li>
              <li className="separator"></li>
              <li>
                <button 
                  onClick={handleLogout}
                  className="logout-link"
                  disabled={loading}
                >
                  <i className="fas fa-sign-out-alt icon"></i>
                  <span>{loading ? "Logging out..." : "Logout"}</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;